import {all} from "redux-saga/effects";
import {authSaga} from "./authSagas";
import {dashboardSaga} from "./dashboardSagas";
import {userSaga} from "./userSagas";
import {referenceSaga} from "./referenceSagas";
import {CPManagersSaga} from "./cpManagersSagas";
import {cpServicesSaga} from "./cpServiceSagas";
import {labelSaga} from "./labelsSagas";
import {servicesSaga} from "./serviceSagas";
import {reportSaga} from "./reportSagas";
import {contentSaga} from "./contentSagas";
import {territorySaga} from "./territorySagas";
import {invoicesSaga} from "./invoicesSagas";

export function* rootSaga(getState) {
  yield all([
    authSaga(),
    dashboardSaga(),
    userSaga(),
    referenceSaga(),
    CPManagersSaga(),
    cpServicesSaga(),
    labelSaga(),
    servicesSaga(),
    reportSaga(),
    contentSaga(),
    territorySaga(),
    invoicesSaga(),
  ]);
}
